import { Amplify } from 'aws-amplify';

import { SnackbarProvider } from 'notistack';

import Router from 'routes/index';

import { useAppInit } from 'hooks/app/useAppInit';

import { logger } from 'utils/logger';
import { ERROR_REASONS } from 'utils/logger/transports/constants';

import { AuthProvider } from 'pages/authentication/AuthProvider';

import AuthInitializer from 'components/AuthInitializer';

import { awsConfig } from './aws-export';
import ThemeCustomization from './themes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

try {
    Amplify.configure(awsConfig);
} catch (err) {
    logger.error(Error('Amplify configuration error'), {
        cause: err,
        tags: {
            reason: ERROR_REASONS.amplify,
        },
    });
}

const queryClient = new QueryClient();

const AppContent = () => {
    useAppInit();
    return (
        <SnackbarProvider maxSnack={5}>
            <AuthInitializer />
            <Router />
        </SnackbarProvider>
    );
};

const App = () => {
    return (
        <ThemeCustomization>
            <AuthProvider>
                <QueryClientProvider client={queryClient}>
                    <AppContent />
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </AuthProvider>
        </ThemeCustomization>
    );
};

export default App;
